// db.ts

let request: IDBOpenDBRequest;
let db: IDBDatabase;
export let DBVersion = 2;

export enum DBStores {
  Sessions = 'Sessions',
}
export const DBName = 'session-logs';
export const initDB = (): Promise<boolean> => {
  return new Promise((resolve) => {
    // open the connection
    request = indexedDB.open(DBName);

    request.onupgradeneeded = () => {
      db = request.result;

      // if the data object store doesn't exist, create it
      if (!db.objectStoreNames.contains(DBStores.Sessions)) {
        console.log('Creating sessions store');
        db.createObjectStore(DBStores.Sessions, { keyPath: 'id', autoIncrement: true });
      }
      // no need to resolve here
    };

    request.onsuccess = () => {
      db = request.result;
      DBVersion = db.version;
      console.log('request.onsuccess - initDB ', DBVersion);
      resolve(true);
      // @ts-ignore
      window.db = db;
    };

    request.onerror = () => {
      resolve(false);
    };
  });
};
const openDatabase = () => {
  return new Promise((resolve, reject) => {
    // Open the database
    const request = indexedDB.open(DBName);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
};

export const exportStore = async (): Promise<any[]> => {
  const db: any = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(DBStores.Sessions, 'readonly');
    const data: any[] = [];

    transaction.oncomplete = () => resolve(data);
    transaction.onerror = () => reject(transaction.error);

    const cursorRequest = transaction.objectStore(DBStores.Sessions).openCursor();

    cursorRequest.onsuccess = (event: any) => {
      const cursor = event.target.result;
      if (cursor) {
        data.push(cursor.value);
        cursor.continue();
      }
    };
  });
};
